// extracted by mini-css-extract-plugin
export default {"container":"Marquee_container__3oaDn","autoSlider":"Marquee_autoSlider__3Ny8J","white":"Marquee_white__hSS7b","moveLeftAnimation":"Marquee_moveLeftAnimation__HZiOt"};